export const navLists = [
    { id: 1, title: "Home" },
    { id: 2, title: "About" },
    { id: 3, title: "Contact" },
    { id: 4, title: "Blog" },
    { id: 5, title: "Careers" },
];
